<template>
  <b-form class="login-form" @submit.prevent="UserCode">
    <div class="form-item text-center forget-title">
      <span>Нууц код оруулах</span>
      <p>
        {{ userSendValue.typeValue }} гэсэн хаяг руу илгээсэн нууц кодыг оруулан
        нэвтэрч орно уу.
      </p>
    </div>
    <div class="form-item forget-form">
      <input
        type="text"
        class="form-control"
        v-model="secretCode"
        placeholder="Нууц код"
        autofocus
        required
      />
    </div>
    <div class="forget-form forget-btn">
      <input
        type="submit"
        class="btn forget-btn-inner"
        value="ҮРГЭЛЖЛҮҮЛЭХ"
        style="margin-top: 0"
        :Disabled="isDisabled"
      />
      <span class="btn forget-btn-inner" @click="back">БОЛИХ</span>
    </div>
    <div class="forget-resend">
      <div class="forget-resend-text" @click="resend">Дахин илгээх</div>
    </div>
    <div class="forget-resend-success" v-if="messageShow">
      <p>{{ message }}</p>
    </div>
    <div class="form-item form-error-out" v-if="error">
      <div class="form-error">
        <div class="error-icon">
          <img src="@/assets/icon/error.png" alt="" />
        </div>
        <div class="error-message">
          <p>{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props: {
    userSendValue: Object,
    userToken: String,
  },
  data() {
    return {
      secretCode: "",
      message: "",
      messageShow: false,
      errorMessage: "",
      error: false,
      isDisabled: false,
    };
  },
  methods: {
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    //back to Login
    back() {
      this.$router.push({ name: "login" });
    },
    stepadd() {
      this.$emit("addStep");
    },
    UserCode() {
      this.isDisabled = true;
      var body = this.userSendValue;
      var username = this.secretCode.replace(/\s/g, "");
      var isnum = /^\d+$/.test(username);
      if (isnum || username.length == 4) {
        var secureCode = this.secretCode.replace(/\s/g, "");
        if (secureCode.length === 4) {
          this.$insProgress.start();
          this.$cardApi
            .post(
              "/auth/recover/check/code",
              //   { tokenId, secureCode },
              {
                type: body.type,
                typeValue: body.realValue,
                systemId: "NominApp",
                tokenId: body.tokenId,
                cardHolderKey: body.cardHolderKey,
                code: secureCode,
              },
              {
                headers: {
                  "Accept-Language": "en-US",
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                },
              }
            )
            .then((response) => {
              if (response.data === true) {
                this.stepadd();
                this.$emit("transferToStep3", body.cardHolderKey, body.tokenId);
                this.$insProgress.finish();
              } else if (response.data.status === 100) {
                this.isDisabled = false;
                this.errorMessage = response.data.message;
                this.error = true;
                this.$insProgress.finish();
              }
            })
            .catch((error) => {
              this.errorMessage = error.response.data.message;
              this.error = true;
              this.isDisabled = false;
            });
        } else {
          this.isDisabled = false;
          this.error = true;
          this.errorMessage = "Та зөвхөн 4 оронтой тоо оруулна уу ?";
        }
      } else {
        this.isDisabled = false;
        this.error = true;
        this.errorMessage = "Та зөвхөн 4 оронтой тоо оруулна уу ?";
      }
    },
    //check username name user input
    checkusername() {
      var username = this.secretCode.replace(/\s/g, "");
      var isnum = /^\d+$/.test(username);
      if (!isnum) {
        this.error = true;
        this.errorMessage = "Та зөвхөн тоо оруулна уу ?";
        this.isDisabled = true;
      } else if (username.length != 4) {
        this.error = true;
        this.errorMessage = "Та зөвхөн 4 оронтой тоо оруулна уу ?";
        this.isDisabled = true;
      } else {
        this.error = false;
        this.errorMessage = "";
        this.isDisabled = false;
      }
    },
    resend() {
      this.$insProgress.start();
      var typeValue = this.userSendValue.realValue;
      var type = this.userSendValue.type;
      var tokenId = this.userSendValue.tokenId;
      var cardHolderKey = this.userSendValue.cardHolderKey;
      this.$cardApi
        .post(
          `/auth/recover/password`,
          {
            tokenId,
            typeValue,
            type,
            systemId: "NominApp",
            cardHolderKey,
          },
          {
            headers: {
              "Accept-Language": "en-US",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data.status === 0) {
            this.message = "Амжилттай илгээгдлээ";
            this.messageShow = true;
            this.$insProgress.finish();
            this.errorMessage = "";
            this.error = false;
          } else if (response.data.status === 100) {
            this.message = "";
            this.messageShow = false;
            this.errorMessage = response.data.message;
            this.error = true;
            this.$insProgress.finish();
          }
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message;
          this.error = true;
        });
    },
  },
};
</script>

<style>
.forget-resend {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-end;
}
.forget-resend-text {
  margin-top: 10px;
  font-size: 13px;
  color: #1660ab;
  cursor: pointer;
}
.forget-resend-success {
  width: 100%;
}
.forget-resend-success p {
  margin-top: 10px;
  font-size: 13px;
  color: #ed3237;
}
</style>
